<p-button
  icon="ico ico-x-close"
  [rounded]="true"
  (click)="toggleSidebar()"
  class="close-button"
  size="large"
  [text]="true"
  styleClass="!text-white"
/>

<header class="">
  <div class="logo">
    <img alt=" " src="/pco-front-assets/puntos-colombia-hb.svg" alt="Logo Puntos Colombia" />
  </div>
</header>

<div class="content">
  <ul>
    <!-- Companies -->
    <li>
      <div class="group">
        <i class="ico ico-building-01"></i>
        <span>Empresas</span>
      </div>

      <ul>
        <li *ngxPermissionsOnly="[roles.TECNICO, roles.VALIDADOR, roles.SOPORTE, roles.VISOR]">
          <a routerLink="companies" routerLinkActive="mnu-active" data-cy="menu-sidebar-empresas">Onboarding</a>
        </li>

        <!-- Aliados : allies/partnercodes -->
        <li
          *ngxPermissionsOnly="[
            roles.TECNICO,
            roles.ROL_BACKOFFICE_VISOR,
            roles.ROL_BACKOFFICE_ADMIN,
            roles.ROL_BACKOFFICE_LOCATIONCREATE,
            roles.BACKOFFICE_CREADOR_CREDENCIALES,
          ]"
        >
          <a routerLink="allies/partnercodes" routerLinkActive="mnu-active" data-cy="menu-sidebar-empresas">Aliados</a>
        </li>
      </ul>
    </li>

    <!-- Products -->
    <li *ngxPermissionsOnly="[roles.MEDIA, roles.TECNICO, roles.VISOR]">
      <div class="group">
        <i class="ico ico-dots-grid"></i>
        <span>Productos</span>
      </div>

      <ul>
        <li>
          <a routerLink="media-services" routerLinkActive="mnu-active" data-cy="menu-sidebar-media-services">
            Audiencia y medios
          </a>
        </li>
      </ul>
    </li>

    <!-- Automatic acumulations -->
    <li *ngxPermissionsOnly="[roles.TECNICO, roles.SOPORTE, roles.VISOR, roles.ADMINISTRADOR_AA]">
      <div class="group">
        <i class="ico ico-credit-card-02"></i>
        <span>Acumulaciones automaticas</span>
      </div>

      <ul>
        <li>
          <a routerLink="automatic-accruals/general" routerLinkActive="mnu-active" data-cy="menu-sidebar-aa-accruals">
            Parametrización
          </a>
        </li>
        <li>
          <a routerLink="automatic-accruals/reports" routerLinkActive="mnu-active" data-cy="menu-sidebar-aa-reports">
            Reportes
          </a>
        </li>
      </ul>
    </li>

    <!-- Events -->
    <li *ngxPermissionsOnly="[roles.TECNICO, roles.VALIDADOR, roles.SOPORTE, roles.VISOR, roles.GESTOR_CAMPANAS]">
      <div class="group">
        <i class="ico ico-announcement-01"></i>
        <a routerLink="events" routerLinkActive="mnu-active" data-cy="menu-sidebar-events">Eventos</a>
      </div>
    </li>
    <!-- Events -->
    <li
      *ngxPermissionsOnly="[
        roles.TECNICO,
        roles.MEDIA,
        roles.ROL_BACKOFFICE_VISOR,
        roles.ROL_BACKOFFICE_ADMIN,
        roles.BACKOFFICE_AUDIENCE_CALCULATE,
      ]"
    >
      <div class="group">
        <i class="ico ico-announcement-01"></i>
        <a routerLink="campaings" routerLinkActive="mnu-active" data-cy="menu-sidebar-events">Campañas</a>
      </div>
    </li>
    <!-- Fraud Inquiry -->
    <li *ngxPermissionsOnly="[roles.TECNICO, roles.ROL_FRAUDE, roles.ROL_BACKOFFICE_VISOR, roles.ROL_BACKOFFICE_ADMIN]">
      <div class="group">
        <i class="ico ico-shield-01"></i>
        <a routerLink="inquiry-fraud" routerLinkActive="mnu-active" data-cy="menu-sidebar-inquiry-fraud"
          >Consulta de Fraude</a
        >
      </div>
    </li>
  </ul>
</div>

<footer>
  <ng-content select="[footer]"></ng-content>
</footer>
